import React from "react";

const Dash = <>&mdash;</>;

export default Dash;
